import React from "react";

export default function Blackbackground({nav, setNav}) {
  return (
    <div
      className={`bs-canvas-overlay bs-canvas-anim bg-dark position-fixed w-100 h-100 ${
        nav ? "show" : ""
      }`}
      onClick={(e) => setNav(false)}
    ></div>
  );
}
